import styled from 'styled-components';

export const LastPublished = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 12px;
  font-weight: 400;
  line-height: 143%; /* 17.16px */
  letter-spacing: 0.17px;
  min-width: fit-content;
  margin-right: 16px;
`;
